import React from 'react';
import styled from 'styled-components';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import CloseButtonGalleryImage from './CloseButton';
import Img from '../../Img';

const FullscreenContainer = styled.div`
  display: ${(props) => (props.isFullscreen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(89, 116, 134, 0.9);
  z-index: 100000;
  align-items: center;
  justify-content: center;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 90%;
  height: 90%;
`;

const FullscreenGalleryImage = ({ isFullscreen, templateColor, imageSrc, onClose }) => {
  return (
    <FullscreenContainer isFullscreen={isFullscreen} onClick={onClose}>
      <TransformWrapper
        wheel={{ disabled: true }}
        doubleClick={{ disabled: true }}
      >
        <TransformComponent
          wrapperStyle={{
            width: '100%',
            height: '100%',
          }}
          contentStyle={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ImageContainer>
            <CloseButtonGalleryImage onClick={onClose}/>
            <Img
              src={imageSrc}
              useSpinner={true}
              spinnerColor={templateColor}
              style={{
                cursor: "zoom-out",
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                pointerEvents: "auto",
              }}
            />
          </ImageContainer>
        </TransformComponent>
      </TransformWrapper>
    </FullscreenContainer>
  );
};

export default FullscreenGalleryImage;
